import { supabase } from './supabaseClient';
import { cantidadParaBD, montoParaBD } from '../utils/validacion';
import { getNegocioId } from './negocioActual';
import { decimalesCantidad } from '../utils/unidades';

// Registra la venta y descuenta stock en una sola operación atómica
// (función registrar_venta en la BD, ver sql/002).
// `opciones.unidad` ('lb'/'kg') permite cantidades con decimales.
export async function registrarVenta(productoId, cantidad, precioUnitario = null, opciones = {}) {
  const { data, error } = await supabase.rpc('registrar_venta', {
    p_negocio_id: getNegocioId(),
    p_producto_id: productoId,
    p_cantidad: cantidadParaBD(cantidad, { nombre: 'cantidad', decimales: decimalesCantidad(opciones.unidad) }),
    p_precio_unitario: precioUnitario,
    p_cliente_id: opciones.clienteId || null,
    p_metodo_pago: opciones.metodoPago || null,
    p_cuenta_id: opciones.cuentaId || null,
    p_fecha: opciones.fecha || null,
  });
  if (error) throw error;
  return data;
}

// Parámetros de registrar_venta_carrito (también se guardan tal cual cuando
// la venta se hace sin internet, ver ventasPendientes.js).
// items: [{ producto_id, cantidad, unidad? }] — unidad 'lb'/'kg' acepta decimales.
export function argsVentaCarrito(items, { clienteId, metodoPago, cuentaId, descuento, concepto, nota, canal, porAnuncio, aCredito, fecha, envio, abonoInicial } = {}) {
  return {
    p_negocio_id: getNegocioId(),
    p_items: items.map((i) => ({
      producto_id: i.producto_id,
      cantidad: cantidadParaBD(i.cantidad, { nombre: 'cantidad', decimales: decimalesCantidad(i.unidad) }),
      descuento: i.descuento ? montoParaBD(i.descuento, { nombre: 'descuento', permitirCero: true }) : 0,
    })),
    p_cliente_id: clienteId || null,
    p_metodo_pago: metodoPago || null,
    p_cuenta_id: cuentaId || null,
    p_descuento: descuento || 0,
    p_concepto: concepto?.trim() || null,
    p_nota: nota?.trim() || null,
    p_canal: canal || null,
    p_por_anuncio: !!porAnuncio,
    p_a_credito: !!aCredito,
    p_fecha: fecha || null,
    p_envio: parseFloat(envio) || 0,
    p_abono_inicial: parseFloat(abonoInicial) || 0,
  };
}

// Vende un carrito completo (varios productos) en una sola transacción.
// `ticket`: número creado en el dispositivo (evita registrar dos veces la misma venta).
export async function registrarVentaCarrito(items, opciones = {}) {
  const { data, error } = await supabase.rpc('registrar_venta_carrito', {
    ...argsVentaCarrito(items, opciones),
    ...(opciones.ticket ? { p_ticket: opciones.ticket } : {}),
  });
  if (error) throw error;
  return data; // ticket_id
}

export async function obtenerVentas({ desde = null } = {}) {
  let query = supabase
    .from('ventas')
    .select('*')
    .eq('negocio_id', getNegocioId())
    .order('vendido_en', { ascending: false });
  if (desde) query = query.gte('vendido_en', desde);
  const { data, error } = await query;
  if (error) throw error;
  return data || [];
}
